app.controller('popupInsuranceStatementController', ['$scope', '$state', '$mdDialog', '$timeout', 'objectHelper',
    'baseModel', 'applicationModel', 'insuranceStatementModel', 'visit', 'diagnosisList', 'patient', 'insuranceStatementType',
    'insurance', 'previewOnly',
    function ($scope, $state, $mdDialog, $timeout, objectHelper, baseModel, applicationModel, insuranceStatementModel,
              visit, diagnosisList, patient, insuranceStatementType, insurance, previewOnly) {

        function beforeSave() {
            $scope.insuranceStatement.visitCard = new VisitCardVO(visit.visitCard.id);

            if(!$scope.diagnosisListLoaded) {
                $scope.insuranceStatement.mainDiagnosis = objectHelper.translateObject(angular.copy($scope.diagnosisList[0].icd10), DictionaryVO);
                $scope.insuranceStatement.diagnosisList = $scope.diagnosisList.map(function(diagnosis) { return diagnosis.icd10; });
                $scope.insuranceStatement.diagnosisList.shift();
            }
        }

        var listeners = {};

        function setData() {
            $scope.forms =  {
                insuranceStatement: null
            };

            if(insurance) {
                $scope.insuranceStatement = insurance;
                $scope.diagnosisListLoaded = true;
            } else {
                $scope.insuranceStatement = new InsuranceStatementVO();
                $scope.insuranceStatement.type = insuranceStatementType;
                $scope.insuranceStatement.ableToAttendExamination = true;
                $scope.insuranceStatement.issueDate = new Date();
                $scope.insuranceStatement.visitCard = visit.visitCard.id;
            }

            $scope.visit = visit;
            $scope.diagnosisList = diagnosisList;
            $scope.patient = patient;
            $scope.presentDate = new Date();

            $scope.previewOnly = previewOnly;
        }

        function setPermissions() {
        }

        function setListeners() {
            listeners.onInsuranceStatementSave = function(insuranceStatement) {
                $scope.insuranceStatement = insuranceStatement;
                var returnObject = {
                    print: false,
                    insurance: $scope.insuranceStatement
                };

                $mdDialog.hide(returnObject);
            };

            listeners.onInsuranceStatementSaveAndPrint = function(insuranceStatement) {
                $scope.insuranceStatement = insuranceStatement;
                $scope.previewOnly = true;
                insuranceStatementModel.downloadPDF($scope.insuranceStatement.id);

                var returnObject = {
                    print: true,
                    insurance: $scope.insuranceStatement
                };

                $mdDialog.hide(returnObject);
            };
        }

        function setActions() {
            $scope.save = function(print) {
                beforeSave();
                $scope.forms.insuranceStatement.$setSubmitted();
                if($scope.forms.insuranceStatement.$valid) {
                    if($scope.insuranceStatement.id) {
                        insuranceStatementModel.update($scope.insuranceStatement).then(function(ref) {
                            checkForDownload(ref);
                        })

                    } else {
                        insuranceStatementModel.save($scope.insuranceStatement).then(function(ref) {
                            checkForDownload(ref);
                        });
                    }
                }


                function checkForDownload(obj) {
                    if(print) {
                        $scope.previewOnly = true;
                        insuranceStatementModel.downloadPDF(obj.id).then(function(link) {
                            window.open(link, '_blank');
                            window.focus();
                            $mdDialog.hide(obj);
                        })
                    } else {
                        $mdDialog.hide(obj);
                    }
                }
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            };


        }

        function configureInterface() {

        }

        function initialize() {

        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);